import { createFileRoute } from '@tanstack/react-router'

import { objectiveFiltersSchema } from '@/modules/objective/core/objective.schema'
import { ObjectivesToPrioritizePage } from '@/modules/objective/presentation/pages/ObjectivesToPrioritize'

export const Route = createFileRoute('/_authenticated/objectives/to-prioritize')({
  component: ObjectivesToPrioritizePage,
  head: () => ({
    meta: [
      {
        title: 'Objectives to prioritize',
      },
    ],
  }),
  validateSearch: objectiveFiltersSchema,
})
